import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import profileReducer from './slices/profileSlice';
import loveshotsReducer from './slices/loveshotsSlice';
import storiesReducer from './slices/storiesSlice';
import messagesReducer from './slices/messagesSlice';
import notificationsReducer from './slices/notificationsSlice';
import loveRequestsReducer from './slices/loveRequestsSlice';
import lovesReducer from './slices/lovesSlice';
import followReducer from './slices/followSlice';
import dashboardReducer from './slices/dashboardSlice';


export const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profileReducer,
    loveshots: loveshotsReducer,
    stories: storiesReducer,
    messages: messagesReducer,
    notifications: notificationsReducer,
    loveRequests: loveRequestsReducer,
    loves: lovesReducer,
    follow: followReducer,
    dashboard: dashboardReducer,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['auth/login/fulfilled'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['items.dates'],
      },
    }),
});

export default store;
